import css from 'styled-jsx/css';
import { colors, fonts } from 'components/styles/variables';

export const resultsListStyles = css`
  .result-list-fixed-height {
    min-height: 1700px;
    width: 100%;
  }
  .result-list-full-width {
    width: 100%;
  }
  .result-list-no-results {
    width: 100%;
    min-height: 300px;
  }
  .result-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: ${colors.WHITE};
    justify-content: start;
    font-family: ${fonts.default};
    align-items: center;
  }
  .result-list-spacer {
    border-bottom: 1px solid ${colors.G2};
    width: 90%;
    height: 1px;
  }
  .result-list-item {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .result-list-desktop-inline-ad {
    margin-top: 24px;
  }
  .result-list-mobile-inline-ad {
    margin-top: 12px;
  }
  .result-list-pagination {
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }

  @media (min-width: 600px) {
    .result-list {
      gap: 24px;
    }
    .result-list-spacer {
      display: none;
    }
  }
`;
